const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			notices: true,
		},
		buttonContext: 'participants',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'evs_participants',
		headRowActions: {
			showSelectColumns: true
		},
		rowActionsProperties: {
			colWidth: '36px'
		},
		rowActions: {
			// delete: true
		},

		dynamicFields: {
			preSelectFieldsByDefault: true
		},

		exportType: 'eventParticipants',
		exportFilenamePrefix: 'export_event_participants',
	},

	model: {
		actionInEffect: '',
		actionModeInEffect: '',
		postProcessingOptions: {},
		resourceFilters: {
			order: [{
				fieldCode: 'createdAt',
				direction: 'asc'
			},{
				fieldCode: 'participantID',
				direction: 'asc'
			}]
		},
		eventData: {},
		participantFields: {},
	},

	methods: {

		onBuild: function(storage){
			if(storage.isClient){
				this.model.eventData = this.getResourceRegisterContent('entityParent') || {}
				this.model.participantFieldsByJSONFieldCode = {
					additionalData: {
						registrationOptionsSwitchKey: 'additionalDataFields',
						component: this.getResourceRegisterContent('additionalDataStructure') || {}
					},
					internalData: {
						registrationOptionsSwitchKey: 'internalDataFields',
						component: this.getResourceRegisterContent('internalDataStructure') || {}
					}
				}

				this.sanitizeDynamicFields()
			}
		},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){
			resourceFilters = resourceFilters || {}

			if(actionKey === 'refreshResources'){
				resourceFilters.baseFilters = {}

				if(this.model.eventData.resourceID){
					resourceFilters.eventID = this.model.eventData.resourceID // used for getCMSEvent resource within refreshResources.source.eventData
					resourceFilters.baseFilters.eventID = this.model.eventData.resourceID // used for getCMSEvents resource within refreshResources.source.load
				}
			}
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			// prevent all participants (without any eventID filter) from being loaded. NOTE: the server does this anyway, but here a request may be saved entirely.
			const eventIDFilterSet = !utils.isEmpty((resourceFilters || {}).baseFilters || {}.eventID)
			return actionKey !== 'refreshResources' || eventIDFilterSet;
		},

		sanitizeDynamicFields: function(initDone = false){
			// init
			const participantFields 	= this.model.participantFieldsByJSONFieldCode
			const registrationOptions 	= (this.model.eventData.attributes || {}).registrationOptions || {}
			let refreshNecessary		= false

			for(const parentJSONFieldCode in participantFields){
				const participantElement = participantFields[parentJSONFieldCode] || {}
				const participantComponent = participantElement.component || {}
				const registrationOptionsSwitchKey = participantElement.registrationOptionsSwitchKey
				const modelFields = (participantComponent.model || {}).fields || []

				for(const modelFieldIndex in modelFields){
					const field = utils.simpleCopy(modelFields[modelFieldIndex] || {})
					if(field.fieldCode){
						const tableFieldAvailable = !!(registrationOptions[registrationOptionsSwitchKey || '~~~NA~~~'] || {})[field.fieldCode]

						// TODO: tell columnSelector when to "preventFieldCodeSelection" = true on eventProperty-onSubmitDone
						field.preventFieldCodeSelection = !tableFieldAvailable

						if(initDone) {
							refreshNecessary = true
							this.setFieldVisibility(field, parentJSONFieldCode, false)
						} else {
							this.addDynamicField(utils.replace(field, {
								dataINT: 1
							}), parentJSONFieldCode, tableFieldAvailable)
						}
					}
				}
			}

			if(refreshNecessary){
				this.refreshFieldVisibility()
			}
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showInsert: function(rowID, rowData, buttonMode){
			// return this.prepareEventParticipantDataStructures().then(() => {
			// 	const {
			// 		additionalDataStructure,
			// 		internalDataStructure
			// 	} = (this.model.eventParticipantDataStructures || {})

				return this.performAndStoreAction(
					'showInsert_event_inEffect',
					this.prepareAction('showInsert_event', undefined, {
						// additionalDataStructure,
						// internalDataStructure
					})
				);
			// })
		},

		showEdit: function(rowID, rowData, buttonMode){
			var entityPrefix = '';
			if(this.hasRoleOption('showIDs')){
				entityPrefix = '#' + rowID + ' - ' + entityPrefix;
			}
			var baseActionKey = 'showEdit_participant'
			var actionKey = baseActionKey;
			actionKey += '_' + rowID;
			var rowAttributes = (rowData || {}).attributes || {}

			// estimate right title for this participant
			let title = `Unknown Participant`
			const titleParts = []
			if(rowAttributes.firstname) titleParts.push(rowAttributes.firstname);
			if(rowAttributes.lastname) titleParts.push(rowAttributes.lastname);
			if(titleParts.length > 0){
				title = titleParts.join(' ')
			}

			// re-perform action if necessary
			if(this.actions[actionKey]){
				return this.performAction(actionKey);
			}
			else if(this.actions[baseActionKey]){
				// return this.prepareEventParticipantDataStructures().then(() => {
				// 	const {
				// 		additionalDataStructure,
				// 		internalDataStructure
				// 	} = (this.model.eventParticipantDataStructures || {})

					return this.performAndStoreAction(
						actionKey,
						this.prepareAction(baseActionKey, undefined, {
							entityParent: utils.replace(rowData, { resourceID: rowID }),
							tabOptions: {
								title: entityPrefix + title,
								icon: 'fi fi-participant'
							},
							// additionalDataStructure,
							// internalDataStructure
						}),
						false
					)
				// })
			}

			return utils.promise.reject();
		},

		// delete: function(rowID, rowData, buttonMode){
		// 	var self = this;
		//
		// 	if(rowID){
		// 		return self.performDecision(
		// 			'confirm',
		// 			{
		// 				component:  self,
		// 				title:      storage.__('hint.delete.really.event.title'),
		// 				message:    storage.__('hint.delete.really.event.message')
		// 			}
		// 		).then(context => {
		// 			if (context.decision.type === 'yes') {
		//
		// 				return this.performAction(
		// 					this.prepareAction('delete_event', rowID)
		// 				).then(context => {
		// 					// refresh event list
		// 					this.refreshData();
		// 					this.callHandler('onDeleteEvent', [rowID])
		// 					return context;
		// 				});
		// 			}
		//
		// 			return utils.promise.reject();
		// 		});
		// 	}
		//
		// 	return utils.promise.reject(new Error('DELETE SUBSCRIBER MISSING SUBSCRIBER_ID'));
		// },

		// prepareEventParticipantDataStructures: function(){
		// 	// prepare data structures if necessary
		// 	if(!this.model.eventParticipantDataStructures) {
		// 		return utils.promise.resolveAll(this, [
		// 			this.loadComponentModelFieldsByNinjaCodeName('eventParticipantAdditionalData'),
		// 			this.loadComponentModelFieldsByNinjaCodeName('eventParticipantInternalData'),
		// 		]).then(response => {
		// 			this.model.eventParticipantDataStructures = {
		// 				additionalDataStructure: response.results[0],
		// 				internalDataStructure: response.results[1]
		// 			}
		//
		// 			return utils.promise.resolve()
		// 		})
		// 	}
		//
		// 	return utils.promise.resolve()
		// },

		// loadComponentModelFieldsByNinjaCodeName: function(ninjaCodeName){
		// 	return this.performAction(
		// 		this.prepareAction(
		// 			'loadComponentModelFieldsByNinjaCodeName',
		// 			ninjaCodeName
		// 		)
		// 	).then(context => (context.action || {}).response)
		// },

		// handleError: function(context){
		// 	const baseError = utils.extractBaseError(context.error);
		//
		// 	// event entry could not be loaded since it is missing
		// 	if(
		// 		((context || {}).component || {}).componentClass === 'templates_propertiesForms_eventPropertiesForm' &&
		// 		baseError.statusCode === 404 &&
		// 		baseError.errorCode === 'REQUEST_HANDLER_RESOURCE_NOT_FOUND_ERROR_2'
		// 	){
		// 		// prevent multiple error messages from being shown at once.
		// 		this.skipFurtherErrorHandling()
		// 		this.refreshData(true);
		// 		return this.performAction(
		// 			this.prepareAction('message', undefined, {
		// 				messageDisplay: {
		// 					message: 'error:events.table.showEdit.missingEventEntry'
		// 				}
		// 			}, {
		// 				rollbackContext: context,
		// 				statusControllerLoadingMessage: '',
		// 				statusControllerSavingMessage:  ''
		// 			})
		// 		);
		// 	}
		//
		// 	// routeContentTree of route could not be loaded since it is missing
		// 	if(
		// 		((context || {}).component || {}).componentClass === 'templates_routeContentTrees_routeContentTrees' &&
		// 		baseError.statusCode === 404 &&
		// 		baseError.errorCode === 'COMPONENT_TREE_BUILDER_ERROR_7'
		// 	){
		// 		// prevent multiple error messages from being shown at once.
		// 		this.skipFurtherErrorHandling()
		// 		this.refreshData(true);
		// 		return this.performAction(
		// 			this.prepareAction('message', undefined, {
		// 				messageDisplay: {
		// 					message: 'error:events.table.showEdit.missingRoute'
		// 				}
		// 			}, {
		// 				rollbackContext: context,
		// 				statusControllerLoadingMessage: '',
		// 				statusControllerSavingMessage:  ''
		// 			})
		// 		);
		// 	}
		//
		// 	context.errorUnhandled = true;
		// 	return utils.promise.resolve(context);
		// },


		// customClickHandler: function(event){
		// 	var bubble = $(event.target).closest('.bubble')
		// 	var tagsColumn = $(event.target).closest('.fieldOf_tags')
		// 	if(bubble.length > 0 && tagsColumn.length > 0){
		// 		var tagKey = bubble.data('tagKey');
		// 		var tagParts = String(tagKey || '').split('_') || [];
		// 		var categoryID = tagParts[0] || 0
		// 		var categoryDataID = tagParts[1] || 0
		// 		if(categoryID && categoryDataID){
		// 			this.triggerClosest('colTagsBubbleSelected', {
		// 				categoryID,
		// 				categoryDataID
		// 			}, 'templates_events_controller')
		// 			return true;
		// 		}
		// 	}
		//
		// 	return false;
		// },

		// onAfterLazyLoad: function(errorOccurred){
		// 	if(!errorOccurred){
		// 		this.updateBubbleHighlighting()
		// 	}
		// },

		// updateBubbleHighlighting: function(){
		// 	var highlightTagBubbles = ((this.model.resourceFilters || {}).filters || {}).tags || [];
		// 	this.$.find('.fieldOf_tags .bubble').removeClass('highlighted');
		// 	if(highlightTagBubbles.length > 0){
		// 		this.$.find(highlightTagBubbles.map(tagKey => `.fieldOf_tags .bubble[data-tag-key="${tagKey}"]`).join(',')).addClass('highlighted');
		// 	}
		// },
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_events_participants_controller', function(controller){
					self.model.controller = controller
				});
			}

			// this.updateBubbleHighlighting()
		},

		async onDecision($element, options){
			// var self = this;
			// TODO: CLEANUP
			if(options.decisionComponent.hasClass('base_modal_modal')){
				if(options.decisionType === 'cancel'){
					await options.decisionComponent.hide();
				// } else if(options.decisionComponent.hasClass('container_templates_propertiesForms_participantPropertiesForm')){
				// 	options.decisionComponent.find('templates_propertiesForms_participantPropertiesForm', function(propertiesFormComponent){
				// 		propertiesFormComponent.submit()
				// 			.then(result => {
				// 				const data = ((result || {}).response || {}).data || {}
				// 				const attributes = data.attributes || {}
				// 				const _primaryKey = attributes[data.primaryKey || 'id']
				//
				// 				options.decisionComponent.hide()
				// 				self.refreshData()
				//
				// 				if(_primaryKey){
				// 					self.showEdit(_primaryKey, data)
				// 				}
				// 			})
				// 	});
				}
			}
		}
	},

	handlers: [
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_eventPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(!insertPerformed){
					const nodeDataData = (nodeData || {}).data || {}
					const nodeDataAttributes = nodeDataData.attributes || {}
					const eventData = this.model.eventData || {}
					const eventDataAttributes = eventData.attributes || {}

					const changedPrimaryKey = nodeDataAttributes[nodeDataData.primaryKey || 'id']
					const myPrimaryKey 		= eventDataAttributes[eventData.primaryKey || 'id'] || eventData.resourceID || 0

					// update registrationOptions if necessary and show the right participant columns according to the changes made within the eventProperties.
					if(changedPrimaryKey && myPrimaryKey && changedPrimaryKey === myPrimaryKey){
						eventDataAttributes.registrationOptions = {
							...(eventDataAttributes.registrationOptions || {}),
							...(nodeDataAttributes.registrationOptions || {}),
						}
						this.sanitizeDynamicFields(true)
					}
				}
			}
		}
	]
}
